import { render, staticRenderFns } from "./shutdowns_edit.vue?vue&type=template&id=2c9de148&"
import script from "./shutdowns_edit.vue?vue&type=script&lang=ts&"
export * from "./shutdowns_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports